import React from 'react'

import * as styles from './NodeContentWrapper.styles'

interface NodeContentWrapperProps {
  children?: React.ReactNode
}

export const NodeContentWrapper = ({ children }: NodeContentWrapperProps) => {
  return <view style={styles.ContentWrapperStyle}>{children}</view>
}
